import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIImage from 'UIComponents/image/UIImage';
import UIIconHolder from 'UIComponents/icon/UIIconHolder';
import UISection from 'UIComponents/section/UISection';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { LORAX } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class AuthorizeHeader extends Component {
  renderImages() {
    const hubspotIcon = /*#__PURE__*/_jsx(UIIconHolder, {
      name: "sprocket",
      padding: 0,
      size: 80,
      color: LORAX
    });
    if (this.props.providerIconUrl) {
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(UIImage, {
          src: this.props.providerIconUrl,
          width: 100,
          height: 100,
          objectFit: "contain",
          responsive: false
        }), /*#__PURE__*/_jsx(UIIconHolder, {
          name: "ellipses",
          padding: 0,
          size: 80,
          color: LORAX
        }), hubspotIcon]
      });
    } else {
      return hubspotIcon;
    }
  }
  render() {
    const {
      providerName
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: "p-x-2",
      children: [/*#__PURE__*/_jsx(UISection, {
        className: "width-100 justify-center m-top-15",
        children: this.renderImages()
      }), /*#__PURE__*/_jsx(UISection, {
        style: {
          maxWidth: 600
        },
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(UITruncateString, {
            placement: "bottom",
            tooltip: providerName,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "oauth.authorization.connecting",
              options: {
                provider: providerName
              }
            })
          })
        })
      })]
    });
  }
}
AuthorizeHeader.propTypes = {
  providerIconUrl: PropTypes.string,
  providerName: PropTypes.string.isRequired
};
export default AuthorizeHeader;